export default __webpack_public_path__ + "static/media/azure.5d1a8fab.png";